import React from "react";
import { VideoCameraIcon } from "@heroicons/react/24/outline";

const VideoLoadingOverlay = ({ isVisible, message }) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-dark-bg z-50">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-500/20 via-purple-500/20 to-pink-500/20 animate-gradient" />

        {/* Animated circles */}
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl animate-blob" />
        <div className="absolute top-1/3 right-1/3 w-96 h-96 bg-purple-500/10 rounded-full blur-3xl animate-blob animation-delay-2000" />
        <div className="absolute bottom-1/4 left-1/2 w-96 h-96 bg-pink-500/10 rounded-full blur-3xl animate-blob animation-delay-4000" />

        {/* Content */}
        <div className="relative h-full flex flex-col items-center justify-center text-center px-4">
          <div className="mb-8">
            <VideoCameraIcon className="w-16 h-16 text-blue-500 mx-auto mb-4 animate-bounce" />
            <h2 className="text-2xl font-bold text-white mb-2">
              Processing Your Video
            </h2>
            <p className="text-lg text-blue-500 font-medium animate-pulse">
              {message}
            </p>
            <p className="text-sm text-gray-400">
              This might take a minute or two...
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoLoadingOverlay;
